import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-twitter-svg',
  templateUrl: './twitter-svg.component.html',
  styleUrls: ['./twitter-svg.component.scss']
})
export class TwitterSvgComponent {
  @HostBinding('class') classes = 'market-quest-icon ';
  @Input() size = 24;
  @Input() fillColor = '#1f69ff';

  constructor() {}
}
